@if (uiState == UIStateEnum.ShowLoading) {
  <c-container>
    <mat-spinner class="center-margin"></mat-spinner>
  </c-container>
} @else {
  <c-container class="mt-5">
    <div class="d-flex justify-content-between align-items-start mb-4">
      <div>
        <h1>Admin Terms of Service</h1>
        <p class="text-muted mb-0"><strong>Effective Date: June 11, 2025</strong></p>
      </div>

      @if (!isEditMode) {
        <button mat-raised-button color="primary" (click)="enterEditMode()" *userHasCausableAdminAccess>
          <mat-icon>edit</mat-icon>
          Edit Terms
        </button>
      } @else {
        <div class="d-flex gap-2">
          <button mat-button (click)="cancelEdit()">Cancel</button>
          <button mat-raised-button color="primary" (click)="saveTerms()">Save</button>
        </div>
      }
    </div>

    @if (!isEditMode) {
      <!-- Normal view -->
      <c-row class="mb-3">
        <c-col>
          <div class="terms-content" *ngIf="adminTerms">
            <markdown [data]="adminTerms.SettingValue"></markdown>
          </div>
          <div *ngIf="!adminTerms">
            <p>No terms available.</p>
          </div>
        </c-col>
      </c-row>
    } @else {
      <!-- Edit mode -->
      <c-row class="mb-3">
        <c-col md="6">
          <div class="editor-panel">
            <div class="panel-header">
              <h6 class="mb-0">Edit Markdown</h6>
            </div>
            <textarea
              class="editor-textarea"
              [(ngModel)]="editableContent"
              placeholder="Enter your terms in Markdown format...">
        </textarea>
          </div>
        </c-col>
        <c-col md="6">
          <div class="preview-panel">
            <div class="panel-header">
              <h6 class="mb-0">Preview</h6>
            </div>
            <div class="preview-content">
              <markdown [data]="editableContent"></markdown>
            </div>
          </div>
        </c-col>
      </c-row>
    }
  </c-container>
}
